import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import Alert from "shared/components/Alert";
import PrimaryButton from "shared/components/PrimaryButton";
import {
  COLOR_ALERT_TITLE,
  COLOR_BLACK_TRANSPARENT,
} from "shared/theme/colors";

export const StyledButton = styled(PrimaryButton)`
  &.MuiButton-root {
    font-size: 1rem;
    font-weight: 700;

    &.contained {
      border-radius: 0.5rem;
    }
  }
`;

export const StyledAlert = styled(Alert)`
  position: fixed;
  right: 24px;
  bottom: 24px;
  width: 360px;
  border-radius: 1rem;
`;

export const StyledTitle = styled(Typography)`
  font-weight: 500;
  color: ${COLOR_ALERT_TITLE};
`;

export const StyledDescription = styled(Typography)`
  font-weight: 400;
  font-size: 0.875rem;
  color: ${COLOR_BLACK_TRANSPARENT(0.8)};
`;
